import {
  GET_DISCOUNT_RECOMMEND_LIST,
  GET_DISCOUNT_RANK_LIST,
  GET_DISCOUNT_RANK_MENU,
  SET_DISCOUNT_RANK_TYPE,
  SET_DISCOUNT_RANK_ORDER,
} from '../constants/discount';

export const getDiscountRecommendList = payload => ({
  type: GET_DISCOUNT_RECOMMEND_LIST,
  payload,
});

export const getDiscountRankList = payload => ({
  type: GET_DISCOUNT_RANK_LIST,
  payload,
});

export const getDiscountRankMenu = payload => ({
  type: GET_DISCOUNT_RANK_MENU,
  payload,
});

export const handleTpye = payload => ({
  type: SET_DISCOUNT_RANK_TYPE,
  payload,
});

export const handleOrder = payload => ({
  type: SET_DISCOUNT_RANK_ORDER,
  payload,
});
